<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Android'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 40px
  height 40px
  background-size 40px 40px
  background-repeat no-repeat
  background-position center
  background-image url('./images/cdk_icon_android.png')
  background-image image-set(url('./images/cdk_icon_android.png') 1x, url('./images/cdk_icon_android@2x.png') 2x)
}
</style>
